<template>
  <div class="rank-box" v-if="isWhiteUser">
    <div class="radio-box" v-if="uuid === '2266452'">
      <el-radio v-model="radio" label="1" @input="getFrame('2266452')"
        >我的語音聽</el-radio
      >
      <el-radio v-model="radio" label="2" @input="getFrame('157263')"
        >𝓤𝓣⋆熊兒ฅ'ω'ฅ的語音聽</el-radio
      >
    </div>

    <iframe ref="iframe" v-show="htmlMsg"></iframe>
    <div v-if="!htmlMsg">
      暂时查询不到流水，请稍后再试。
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Rank',
  props: {
    isWhiteUser: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      htmlMsg: '',
      radio: '1'
    };
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getFrame(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['token'])
    // uuid() {
    //   return this.userInfo ? this.userInfo.uuid : '';
    // }
  },
  methods: {
    async getFrame(uuid) {
      try {
        const url = `https://devops.nicee.app/api/voiceroom/admin?uuid=${uuid}&token=${this.token}`;
        const res = await this.$http.get(url);
        if (res && res.html) {
          this.htmlMsg = res.html;
          this.$nextTick(() => {
            const iframe = this.$refs.iframe;
            iframe.contentDocument.open();
            iframe.contentDocument.write(res.html);
            iframe.contentDocument.close();
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.rank-box {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
  .radio-box {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
}
</style>
